import React, { useEffect, useRef, useState } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';

export default function MapFrame({ children, testid, tools = null }) {
  const ref = useRef(null);
  const [full, setFull] = useState(false);
  useEffect(() => {
    const on = () => setFull(document.fullscreenElement === ref.current);
    document.addEventListener('fullscreenchange', on);
    return () => document.removeEventListener('fullscreenchange', on);
  }, []);
  const toggle = () => (full ? document.exitFullscreen() : ref.current?.requestFullscreen?.());
  return (
    <div ref={ref} className="wide-map relative" data-testid={testid}>
      <div className="absolute top-3 right-3 z-10 flex gap-1.5">
        {tools}
        <button onClick={toggle} className="h-9 px-3 inline-flex items-center gap-2 text-xs rounded-sm bg-[#0B0D10] border border-[#2A2F36] text-[#E5E5E5] hover:border-[#D4AF37] hover:text-[#D4AF37]" data-testid={`${testid}-fullscreen`}>
          {full ? <Minimize2 size={14} /> : <Maximize2 size={14} />}{full ? 'Esci da schermo intero' : 'Schermo intero'}
        </button>
      </div>
      {children}
    </div>
  );
}
